<div class="date-picker-range">
    <kendo-datepicker [value]="startDate" class="filter-date"
                      [min]="minDate" [popupSettings]="popupSettings"
                      (valueChange)="onStartDateChange($event)"></kendo-datepicker>
    <kendo-numerictextbox [value]="startDateRange"
                          [format]="'n0'" (valueChange)="onStartDateRangeChange($event)"
                          [min]="0"
                          [decimals]="0" class="filter-input">
    </kendo-numerictextbox>
</div>
<div class="date-picker-range">
    <kendo-datepicker [(value)]="endDate" class="filter-date"
                      [min]="startDate" [popupSettings]="popupSettings"
                      (valueChange)="onEndDateChange($event)"></kendo-datepicker>
    <kendo-numerictextbox [(value)]="endDateRange"
                          [format]="'n0'" (valueChange)="onEndDateRangeChange($event)"
                          [min]="0"
                          [max]="99"
                          [decimals]="0" class="filter-input">
    </kendo-numerictextbox>
</div>
